import { authmemgroup } from "./authentication.reducer";
import { feedMemGroupData } from "./feedMemData.reducer";
// import { Mempass } from "./Mempass.reducer";
// import { MemRegis } from "./MemRegis.reducer";
// import { MemForget } from "./MemForget.reducer";
import { headerNav } from "./HeaderNav.reducer";
import { SideBar } from "./SideBar.reducer";

export const memgroupReducers = {
    authmemgroup,
    feedMemGroupData,
    headerNav,
    SideBar,
    // Mempass,
    // MemRegis,
    // MemForget,
};
